export default __webpack_public_path__ + "static/media/loading.66c69335.gif";